import React from "react";
import styled, { css } from "styled-components";
const Container = styled.div(
  ({ theme, $isActive, $isClickable }) => css`
    border: 1px solid ${theme.colors.cards.border};
    background-color: ${theme.colors.cards.background};
    border-radius: ${theme.spacings.xs};
    padding: ${theme.spacings.sm};

    ${$isActive && css`
      outline: 1px solid ${theme.colors.input.borderFocus};
    `}

    ${$isClickable && css`
      cursor: pointer;

      &:hover,
      &:focus-visible {
        outline: 1px solid ${theme.colors.input.borderFocus};
        box-shadow: ${theme.colors.input.boxShadow};
      }
    `}
  `
);
const AccessibleCard = ({
  onClick = void 0,
  isActive = false,
  children = null,
  className = void 0,
  title = void 0
}) => {
  const isClickable = typeof onClick === "function";
  const asProp = isClickable ? "button" : "div";
  const typeProp = isClickable ? "button" : void 0;
  return /* @__PURE__ */ React.createElement(
    Container,
    {
      title,
      as: asProp,
      type: typeProp,
      className,
      $isActive: isActive,
      onClick,
      $isClickable: typeof onClick === "function"
    },
    children
  );
};
export default AccessibleCard;
